import styled from 'styled-components';
import SharedNavBar from '../../../components/NavBar';

export const StyledNavBar = styled(SharedNavBar)``;
